import React, { useCallback } from 'react'
import { Input } from 'antd'
import Search from 'antd/lib/input/Search'
import { SearchOutlined } from '@ant-design/icons'

export const SearchInput = ({ value, onChange, onFocus, onBlur, onClick }) => {
  const handleChange = useCallback((event) => onChange(event.target.value), [
    onChange,
  ])

  return (
    <Input
      // value={value}
      onChange={handleChange}
      placeholder="Search for song"
      addonAfter={<SearchOutlined />}
      onFocus={onFocus}
      onBlur={onBlur}
      onClick={onClick}
    />
  )
}
